export default __webpack_public_path__ + "static/media/ISIPAY_LOGO.e69ed7e7.png";